import { fetchFeedHealth } from "./health.js";
import { nextHealthPollDelay } from "./polling.js";
import { ResourceStore, type ResourceState } from "./resource-store.js";
import type { FeedHealth } from "./types.js";

export type FeedHealthState = ResourceState<FeedHealth>;

export interface HealthStoreOptions {
  fetcher?: (feedId: string, signal: AbortSignal) => Promise<FeedHealth>;
  now?: () => number;
}

/**
 * What the product has established about each feed, live, on each feed's own clock.
 *
 * The console shows every feed's verdict at once and the per-feed page shows the same
 * feed's evidence; both read this, so a feed is asked about once however many places
 * are showing it.
 */
export class FeedHealthStore extends ResourceStore<FeedHealth> {
  constructor(options: HealthStoreOptions = {}) {
    super({
      fetcher: options.fetcher ?? fetchFeedHealth,
      delay: nextHealthPollDelay,
      ...(options.now ? { now: options.now } : {}),
    });
  }
}

export const feedHealthStore = new FeedHealthStore();
